import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServiciodepedidovigenteService {


  constructor() { }

  datosdeusuario;
  creditosdelusuario;

  salidadeservicio;
  origenHaciaDashboard;

  arrayResultadosReporte=[]

  reporteSeleccionado=''

  funciondelservicio(entrada, callback){
    console.log("al servicio llega esto: "+ entrada.id)
    this.salidadeservicio = entrada;
    callback();
  }

  ;


}
